import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SelectArrowIcon, SelectButton, SelectDropdown, SelectOption } from '../../../styles/styles';
import arrowDownIconGreen from "../../../images/arrow-right-green.svg";


const LANG_OPTIONS = [
  { lng: 'ru', label: 'Русский', code: 'RU' },
  { lng: 'sr', label: 'Srpski', code: 'SR' },
  { lng: 'en', label: 'English', code: 'EN' },
  //{ lng: 'de', label: 'Deutsch', code: 'DE' },
];

export default function LanguageSelector({ width = '170px', onClose, useCodeLabels = false }) {
  const { i18n } = useTranslation();
  const current = (i18n.resolvedLanguage || i18n.language || 'ru').split('-')[0];
  const [open, setOpen] = useState(false);
  const btnRef = useRef(null);
  const dropdownRef = useRef(null);

  const getOptionLabel = (option) => (useCodeLabels ? option.code : option.label);

  const currentOption = LANG_OPTIONS.find((o) => o.lng === current);
  const currentLabel = currentOption
    ? getOptionLabel(currentOption)
    : current.toUpperCase();

  // закрытие по клику вне
  useEffect(() => {
    const handler = (e) => {
      if (!dropdownRef.current) return;
      if (dropdownRef.current.contains(e.target) || btnRef.current.contains(e.target)) return;
      setOpen(false);
      onClose?.();
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [onClose]);

  const change = async (lng) => {
    await i18n.changeLanguage(lng);
    document.documentElement.lang = lng;
    setOpen(false);
    onClose?.();
  };

  return (


    
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <SelectButton
        ref={btnRef}
        onClick={() => setOpen(o => !o)}
        aria-haspopup="listbox"
        aria-expanded={open}
        aria-label="Select language"
      >
        {currentLabel} <span aria-hidden><SelectArrowIcon
                        src={arrowDownIconGreen}
                        style={{
                          transform: open ? "rotate(-90deg)" : "rotate(90deg)",
                        }}
                      /></span>
      </SelectButton>

      {open && (
        <div
          ref={dropdownRef}
          style={{ position: 'absolute', zIndex: 10, marginTop: 6 }}
        >
          <SelectDropdown width={width}>
            {LANG_OPTIONS.map((option) => (
              <SelectOption
                key={option.lng}
                onClick={() => change(option.lng)}
                align="flex-start"
                justify="flex-start"
                style={{ fontWeight: option.lng === current ? 600 : 400 }}
                role="option"
                aria-selected={option.lng === current}
              >
                {getOptionLabel(option)}
              </SelectOption>
            ))}
          </SelectDropdown>
        </div>
      )}
    </div>
  );
}
